/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseDTOListBankRecord } from '../models/ApiResponseDTOListBankRecord';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class BankApiService {

    /**
     * Get Bank
     * Retrieves a list of banks.
     * @returns ApiResponseDTOListBankRecord OK
     * @throws ApiError
     */
    public static getBanks(): CancelablePromise<ApiResponseDTOListBankRecord> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/bank',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                501: `Not Implemented`,
                503: `Service Unavailable`,
            },
        });
    }

}
